import { render, staticRenderFns } from "./OrganizationBranchDailyWork.vue?vue&type=template&id=15c610e6&scoped=true"
import script from "./OrganizationBranchDailyWork.vue?vue&type=script&lang=js"
export * from "./OrganizationBranchDailyWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c610e6",
  null
  
)

export default component.exports